import { Tooltip } from '@mui/material';
import React from 'react';

const TooltipUI = (props) => {
  const { slotProps } = props;
  return (
    <Tooltip
      {...props}
      slotProps={{
        ...slotProps,
        tooltip: {
          ...slotProps?.tooltip,
          sx: {
            color: '#514E6A',
            backgroundColor: '#ffff',
            boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
            fontSize: '14px',
            maxWidth: 500,
            whiteSpace: 'pre-line',
            ...slotProps?.tooltip?.sx,
          },
        },
        arrow: {
          ...slotProps?.arrow,
          sx: {
            color: '#ffff',
            ...slotProps?.arrow?.sx,
          },
        },
      }}
    />
  );
};

export default TooltipUI;
